// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b5f3aa29","453":"7293cc9b","667":"12747440","781":"b4b3e7fc","867":"af712c9c","977":"01172a94"}[chunkId] + ".chunk.js";
};